import React, { useContext } from "react";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import Switch from "react-switch";

import ToolTip from "../../../components/shared/ToolTip/ToolTip";
import IconBEV from "../../assets/images/icons/icon-electric.svg";
import IconPHEV from "../../assets/images/icons/icon-hybrid.svg";
import { useIntl } from "react-intl";

const EVFilterControls = ({ vehicles }) => {
  const intl = useIntl();
  const userPrefs = useContext(UserPrefsContext);
  const formFactorFilterData = userPrefs.get("vehicleFormFactorFilters");
  const fuelTypeFilterData = userPrefs.get("vehicleFuelTypeFilters");

  const updateFormFactorFilter = (e, key) => {
    e.preventDefault();
    let newFilters = Object.assign({}, formFactorFilterData);
    if (key === "suv") {
      newFilters["crossover"] = !newFilters["crossover"];
    }
    newFilters[key] = !newFilters[key];
    userPrefs.set({
      vehicleFormFactorFilters: newFilters,
    });
  };

   const renderedFormFactorFilters = Object.keys(formFactorFilterData).map(
     (filterKey, i) => {
       const filterName =
         filterKey === "suv"
           ? "suvcrossover"
           : `${filterKey.charAt(0).toLowerCase()}${filterKey.substr(1)}`;

       if (filterKey === "crossover") {
         return null;
       }
       return filterName === "suvcrossover" ? (
         <button
           className={
             formFactorFilterData[filterKey]
               ? "btn-filter wide active"
               : "btn-filter wide"
           }
           key={i}
           aria-pressed={!!formFactorFilterData[filterKey]}
           onClick={(e) => updateFormFactorFilter(e, filterKey)}
         >
           {intl.formatMessage
             ? intl.formatMessage({
                 id: `vehicle.type.${filterName}`,
               })
             : `${filterName}`}
         </button>
       ) : (
         <button
           className={
             formFactorFilterData[filterKey]
               ? "btn-filter active"
               : "btn-filter"
           }
           key={i}
           aria-pressed={!!formFactorFilterData[filterKey]}
           onClick={(e) => updateFormFactorFilter(e, filterKey)}
         >
           {intl.formatMessage
             ? intl.formatMessage({
                 id: `vehicle.type.${filterName}`,
               })
             : `${filterName}`}
         </button>
       );
     }
   );

const updateFuelTypeFilter = (checked, selectedKey) => {
  const isLastSwitchOn =
    Object.values(fuelTypeFilterData).filter(Boolean).length === 1 &&
    fuelTypeFilterData[selectedKey];

  if (isLastSwitchOn && !checked) {
    return;
  }

  const newFilters = Object.keys(fuelTypeFilterData).reduce((acc, key) => {
    acc[key] =
      key === selectedKey ? !fuelTypeFilterData[key] : fuelTypeFilterData[key];
    return acc;
  }, {});

  userPrefs.set({
    vehicleFuelTypeFilters: newFilters,
  });
};

  const renderedFuelTypeFilters = Object.keys(fuelTypeFilterData).map(
    (filterKey, i) => {
      let filterName = "";
      let filterIconSrc = "";
      switch (filterKey) {
        case "bev":
          filterName = "All-Electric";
          filterIconSrc = IconBEV;
          break;
        case "phev":
          filterName = "Plug-in Hybrid";
          filterIconSrc = IconPHEV;
          break;
        default:
      }

      return (
        <div key={i} className="filter-switch">
          <div className={i !== 0 ? "filter-label" : "filter-label first"}>
            <span className="badge">
              <img src={filterIconSrc} alt="" />
            </span>
            <label htmlFor={filterKey} className="name not-label">
              {filterName}
            </label>
            <div className="switch">
              <Switch
                id={filterKey}
                checked={fuelTypeFilterData[filterKey] ? true : false}
                onChange={(checked) => updateFuelTypeFilter(checked, filterKey)}
                onColor="#EB1700"
                offColor="#191919"
                uncheckedIcon={false}
                checkedIcon={false}
              />
            </div>
            <div className="clearfix"></div>
          </div>
        </div>
      );
    }
  );

  return (
    <form className="ev-filter-controls">
      <div className="form-group">
        <span className="label-style">
          Fuel
         
        </span>
        <div className="btn-block-container">{renderedFuelTypeFilters}</div>
      </div>
      <div className="form-group">
        <span className="label-style">
          Type
          <ToolTip
            message="Select all vehicle body types you are interested in."
            id="type_tooltip"
          />
        </span>
        <div className="btn-grid-container">{renderedFormFactorFilters}</div>
      </div>
    </form>
  );
};

export default EVFilterControls;
